/* eslint-disable max-len */
import { Navigate, Route, Routes } from 'react-router-dom';

import NotAuthorized from '../pages/NotAuthorized';
import Notfound from '../pages/Notfound';

import * as Access from '../pages/TenantPages/AccessControl';
import Integration from '../pages/TenantPages/Integration';
import AiAgents from '../pages/SuperadminPages/AiAgents';

import IntegrationsSuperadmin from '../pages/SuperadminPages/IntegrationModel';
import Jobs from '../pages/SuperadminPages/Jobs';
import AdminMain from '../pages/SuperadminPages/Main';
import Contacts from '../pages/SuperadminPages/Contacts';
import ContactDispatch from '../pages/SuperadminPages/Contacts/Dispatch';
import AccessReportsDashboard from '../pages/SuperadminPages/Reports/Access';
import SalesReportsDashboard from '../pages/SuperadminPages/Reports/Sales';
import SystemLogs from '../pages/SuperadminPages/SystemLogs';
import Tenant from '../pages/SuperadminPages/Tenant';
import Users from '../pages/SuperadminPages/Users';

import Forgotpass from '../pages/Auth/Forgotpass';
import Resetpass from '../pages/Auth/Resetpass';
import Signin from '../pages/Auth/SignIn/SignInPage';

import AdvantageClub from '../pages/TenantPages/AdvantageClub/AdvantageClub';
import AdvClubBalance from '../pages/TenantPages/AdvantageClub/Balance';
import AdvClubHistory from '../pages/TenantPages/AdvantageClub/Historic';

import SurveysInsight from '../pages/TenantPages/Dashboard/MarketingResearch';
import DashboardSales from '../pages/TenantPages/Dashboard/Sales';
import DashboardLog from '../pages/TenantPages/Dashboard/Sales/Pages/Log';
import DashboardSettings from '../pages/TenantPages/Dashboard/Sales/Pages/Settings';
import DashboardScheduledVisits from '../pages/TenantPages/Dashboard/ScheduledVisits';

import Banners from '../pages/TenantPages/Registrations/Banners';
import CommunicationAutomation from '../pages/TenantPages/Registrations/CommunicationAutomation';
import CommunicationGroup from '../pages/TenantPages/Registrations/CommunicationGroup';
import Goal from '../pages/TenantPages/Registrations/Goal';
import Motives from '../pages/TenantPages/Registrations/Motives';
import Templates from '../pages/TenantPages/Registrations/Templates';
import Reports from '../pages/TenantPages/Reports';
import SmSellCustom from '../pages/TenantPages/SmartsellCustomization/TenantCustomLibsPage';
import Upload from '../pages/TenantPages/Upload';

import NewCustomer from '../pages/TenantPages/Logs/NewCustomer';
import OrderChange from '../pages/TenantPages/Logs/OrderChange';

import FormsPage from '../pages/TenantPages/Forms/FormsPage';
import VisitRoutinesPage from '../pages/TenantPages/VisitSchedule/VisitSchedule';
import Taxes from '../pages/TenantPages/Taxes';

import ExternalAuthentication from './PrivateRoutes/ExternalAuthentication';
import Private from './PrivateRoutes/Private';

import Parameters from '../pages/TenantPages/Configurations/Parameters';
import SellersParameters from '../pages/TenantPages/Configurations/SellersParameters';
import EdiCustomers from '../pages/TenantPages/EdiCustomers';
import EdiLayout from '../pages/TenantPages/EdiLayout';
import EdiPaymentConditionsTSX from '../pages/TenantPages/EdiPaymentConditions';
import MixCustomers from '../pages/TenantPages/MixCustomers';
import Audience from '../pages/TenantPages/Registrations/Audience';
import VisitMotivesPage from '../pages/TenantPages/VisitSchedule/VisitMotives';

import { UrlPaths, UrlPathsSuper } from '../enums/urlPaths.enum';
import SuperSmartsellAppVersionTSX from '../pages/SuperadminPages/SmartsellAppVersions';
import EmailTSX from '../pages/TenantPages/Email';
import ExporterJSX from '../pages/TenantPages/Exporter';
import ImporterJSX from '../pages/TenantPages/Importer';
import SmartsellAppVersionTSX from '../pages/TenantPages/SmartsellAppVersion';
import ApprovalGroupsPage from '../pages/TenantPages/Approvals/ApprovalGroups';
import OrdersWithPendenciesPage from '../pages/TenantPages/Approvals/OrdersWithPendencies';
import SmartsellSyncSellerLockTSX from '../pages/TenantPages/SmartsellSync';
import MessagesPage from '../pages/TenantPages/Messages';
import BackgroundProcessesPage from '../pages/TenantPages/Processes/BackgroundProcesses';
import HelpCenterPage from '../pages/HelpCenter';

import AccessControlTSX from '../pages/SuperadminPages/AccessControl';
import AuthSettingTSX from '../pages/TenantPages/AccessControl/AuthSetting/AuthSettingTSX';
import FastmanagerPageTSX from '../pages/TenantPages/FastmanagerPage/FastmanagerPageTSX';
import OrdersPageTSX from '../pages/TenantPages/Orders/OrdersPage';
import OrderStatusPage from '../pages/TenantPages/Orders/OrderStatus';
import ProductsSellersPage from '../pages/TenantPages/Products/ProductsSellersPage/ProductsSellersPage';
import ProductsPage from '../pages/TenantPages/Products/ProductsPage';
import DatasyncPage from '../pages/TenantPages/Datasync';
import TemporaryFilesPage from '../pages/TenantPages/Files/TemporaryFiles';
import DatabaseManagementPage from '../pages/TenantPages/System/DatabaseManagement';
import TableExtensionsPage from '../pages/TenantPages/DatabaseManagement/TableExtensions';
import DbMapPage from '../pages/TenantPages/DatabaseManagement/DbMap';

const RouteManage = () => (
  <Routes>
    <Route path={UrlPaths.DATASYNC} element={<Private component={DatasyncPage} />} />
    <Route path={UrlPaths.TEMP_FILES} element={<Private component={TemporaryFilesPage} />} />
    <Route
      path={UrlPaths.DATABASE_MANAGEMENT}
      element={<Private component={DatabaseManagementPage} />}
    />
    <Route path={UrlPaths.HELP_CENTER} element={<Private component={HelpCenterPage} />} />
    <Route path={UrlPaths.TABLE_EXTENSIONS} element={<Private component={TableExtensionsPage} />} />
    <Route
      path={UrlPaths.DB_MAP}
      element={<Private component={DbMapPage} />}
    />
    <Route path={UrlPaths.ROOT} element={<Navigate to={UrlPaths.LOGIN} />} />
    <Route path={UrlPaths.LOGIN + '/:tenantId?'} element={<Signin />} />

    <Route path={UrlPaths.DASHBOARD_SALES} element={<Private component={DashboardSales} />} />
    <Route
      path={UrlPaths.DASHBOARD_MARKETING_RESEARCH_METRICS}
      element={<Private component={SurveysInsight} />}
    />
    <Route
      path={UrlPaths.DASHBOARD_SCHEDULED_VISITS}
      element={<Private component={DashboardScheduledVisits} />}
    />
    <Route path={UrlPaths.DASHBOARD_LOGS} element={<Private component={DashboardLog} />} />
    <Route path={UrlPaths.DASHBOARD_SETTINGS} element={<Private component={DashboardSettings} />} />

    <Route path={UrlPaths.ORDERS} element={<Private component={OrdersPageTSX} />} />
    <Route path={UrlPaths.ORDER_STATUS} element={<Private component={OrderStatusPage} />} />

    <Route path={UrlPaths.REPORTS} element={<Private component={Reports} />} />

    <Route path={UrlPaths.ADVANTAGE_CLUB} element={<Private component={AdvantageClub} />} />
    <Route
      path={UrlPaths.ADVANTAGE_CLUB_HISTORY}
      element={<Private component={AdvClubHistory} />}
    />
    <Route
      path={UrlPaths.ADVANTAGE_CLUB_BALANCE}
      element={<Private component={AdvClubBalance} />}
    />

    <Route path={UrlPaths.SMARTSELL_CUSTOMIZATION} element={<Private component={SmSellCustom} />} />

    <Route path={UrlPaths.TEMPLATES} element={<Private component={Templates} />} />

    <Route path={UrlPaths.FORGOT_PASSWORD} element={<Forgotpass />} />

    <Route path={UrlPaths.RESET_PASSWORD} element={<Resetpass />} />

    <Route path={UrlPaths.USERS} element={<Private component={Access.Users} />} />

    <Route path={UrlPaths.API_KEYS} element={<Private component={Access.ApiKeys} />} />

    <Route path={UrlPaths.ROLES} element={<Private component={Access.Roles} />} />

    <Route path={UrlPaths.ORDERS_WITH_PENDENCIES} element={<Private component={OrdersWithPendenciesPage} />} />
    <Route path={UrlPaths.APPROVAL_GROUPS} element={<Private component={ApprovalGroupsPage} />} />
    <Route path={UrlPaths.ACCESS_BLOCKS} element={<Private component={Access.AccessBlocks} />} />

    <Route path={UrlPaths.UPLOAD} element={<Private component={Upload} />} />
    <Route path={UrlPaths.TAXES} element={<Private component={Taxes} />} />

    <Route path="/integration/:integration" element={<Private component={Integration} />} />

    <Route path={UrlPaths.GOALS} element={<Private component={Goal} />} />

    <Route path={UrlPaths.MOTIVES} element={<Private component={Motives} />} />

    <Route
      path={UrlPaths.COMMUNICATION_GROUPS}
      element={<Private component={CommunicationGroup} />}
    />

    <Route
      path={UrlPaths.COMMUNICATION_AUTOMATION}
      element={<Private component={CommunicationAutomation} />}
    />
    <Route path={UrlPaths.MESSAGES} element={<Private component={MessagesPage} />} />

    <Route
      path={UrlPaths.BACKGROUND_PROCESSES}
      element={<Private component={BackgroundProcessesPage} />}
    />

    <Route path={UrlPaths.AUDIENCES} element={<Private component={Audience} />} />

    <Route path={UrlPaths.LOGS_ORDER_CHANGE} element={<Private component={OrderChange} />} />

    <Route path={UrlPaths.LOGS_NEW_CUSTOMER} element={<Private component={NewCustomer} />} />

    <Route path={UrlPaths.BANNERS} element={<Private component={Banners} />} />

    <Route path={UrlPaths.CONFIG_PARAMETERS} element={<Private component={Parameters} />} />

    <Route
      path={UrlPaths.CONFIG_SELLERS_PARAMETERS}
      element={<Private component={SellersParameters} />}
    />

    <Route path={UrlPaths.VISIT_SCHEDULE} element={<Private component={VisitRoutinesPage} />} />

    <Route path={UrlPaths.VISIT_MOTIVES} element={<Private component={VisitMotivesPage} />} />

    <Route path={UrlPaths.FORMS} element={<Private component={FormsPage} />} />

    <Route path={UrlPaths.ACCESS_PAGE_WITH_TOKEN} element={<ExternalAuthentication />} />

    <Route path={UrlPaths.EDI_LAYOUT} element={<Private component={EdiLayout} />} />
    <Route path={UrlPaths.EDI_CUSTOMERS} element={<Private component={EdiCustomers} />} />
    <Route
      path={UrlPaths.EDI_PAYMENT_CONDITION}
      element={<Private component={EdiPaymentConditionsTSX} />}
    />
    <Route path={UrlPaths.MIX_CUSTOMERS} element={<Private component={MixCustomers} />} />

    <Route path={UrlPaths.IMPORTER} element={<Private component={ImporterJSX} />} />

    <Route path={UrlPaths.EXPORTER} element={<Private component={ExporterJSX} />} />

    <Route path={UrlPaths.EMAIL} element={<Private component={EmailTSX} />} />

    <Route
      path={UrlPaths.INTEGRATION_FASTMANAGER}
      element={<Private component={FastmanagerPageTSX} />}
    />

    <Route
      path={UrlPaths.SMARTSELL_SYNC_SELLER_LOCK}
      element={<Private component={SmartsellSyncSellerLockTSX} />}
    />

    <Route
      path={UrlPaths.SMARTSELL_APP_VERSION}
      element={<Private component={SmartsellAppVersionTSX} />}
    />

    <Route path={UrlPaths.AUTH_SETTING} element={<Private component={AuthSettingTSX} />} />

    <Route path={UrlPaths.PRODUCTS_SELLERS} element={<Private component={ProductsSellersPage} />} />
    <Route path={UrlPaths.PRODUCTS} element={<Private component={ProductsPage} />} />

    {/* Start -- Superadmin */}
    <>
      <Route path={UrlPathsSuper.LOGIN} element={<Signin />} />
      <Route path={UrlPathsSuper.ROOT} element={<Signin />} />

      <Route path={UrlPathsSuper.HOME} element={<Private component={AdminMain} />} />
      <Route path={UrlPathsSuper.HOME_SALES} element={<Private component={SalesReportsDashboard} />} />
      <Route path={UrlPathsSuper.HOME_ACCESS} element={<Private component={AccessReportsDashboard} />} />

      <Route path={UrlPathsSuper.TENANTS} element={<Private component={Tenant} />} />
      <Route path={UrlPathsSuper.CONTACTS} element={<Private component={Contacts} />} />
      <Route path={UrlPathsSuper.CONTACTS_DISPATCH} element={<Private component={ContactDispatch} />} />
      <Route path={UrlPathsSuper.USERS} element={<Private component={Users} />} />
      <Route path={UrlPathsSuper.JOBS} element={<Private component={Jobs} />} />

      <Route
        path={UrlPathsSuper.INTEGRATION_MODELS}
        element={<Private component={IntegrationsSuperadmin} />}
      />

      <Route path={UrlPathsSuper.AI_AGENTS} element={<Private component={AiAgents} />} />

      <Route path={UrlPathsSuper.SYSTEM_LOGS} element={<Private component={SystemLogs} />} />

      <Route
        path={UrlPathsSuper.SMARTSELL_APP_VERSIONS}
        element={<Private component={SuperSmartsellAppVersionTSX} />}
      />

      <Route
        path={UrlPathsSuper.ACCESS_CONTROL}
        element={<Private component={AccessControlTSX} />}
      />
    </>
    {/* End -- Superadmin */}

    <Route path={UrlPaths.NOT_AUTHORIZED} element={<NotAuthorized />} />

    <Route path="*" element={<Notfound />} />
  </Routes>
);

export default RouteManage;
